import React, {useContext, useEffect} from 'react';
import {sideMenuContext} from '../../../router/IndexRouter';
import {Arguments} from '../common/Arguments';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';
import {Button} from 'antd';
import {SortByMemberPost} from '../common/SortListByPost';
import '../../../components/sandbox/index.css';

export default function MeetingDetailAdmin(props) {
	const {currentItem} = useContext(sideMenuContext);
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/home/api!organizationMeetingNotice.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '社会组织',
			dataIndex: 'organization_name',
			width: 180,
		},
		{
			title: '姓名',
			dataIndex: 'member_name',
			width: 100,
			sorter: (a, b) => a.member_name.localeCompare(b.member_name),
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '性别',
			dataIndex: 'member_sex',
			width: 80,
		},
		{
			title: '出生日期',
			dataIndex: 'member_born',
			width: 120,
		},
		{
			title: '民族',
			dataIndex: 'member_mz',
			width: 80,
		},
		{
			title: '政治面貌',
			dataIndex: 'member_zzmm',
			width: 100,
		},
		{
			title: '文化程度',
			dataIndex: 'member_educational',
			width: 100,
		},
		{
			title: '社团职务',
			dataIndex: 'member_post',
			width: 140,
		},
		{
			title: '工作单位（或原单位）',
			dataIndex: 'member_unit',
			width: 180,
		},
		{
			title: '职务',
			dataIndex: 'organization_post',
			width: 100,
		},
		{
			title: '职称',
			dataIndex: 'member_professional',
			width: 100,
		},
		{
			title: '身份证号',
			dataIndex: 'member_sfz',
		},
		{
			title: '手机号',
			dataIndex: 'mobile_phone',
		},
	];

	// 筛选出当前 organizationId 下属于本次会议（meetingId）的数据
	const regEx = /\/(\d+)$/;
	const match = window.location.href.match(regEx);
	const meetingId = match ? match[1] : null;
	const filteredData = meetingId ? dataSource.filter(data => data.meeting_id === meetingId) : [];
	const indexDataSource = SortByMemberPost(filteredData).map((data, index) => ({showIndex: index + 1, ...data}));

	const newData = indexDataSource.map(
		(
			{
				organization_name,
				member_name,
				member_sex,
				member_born,
				member_mz,
				member_zzmm,
				member_educational,
				organization_post,
				member_unit,
				member_post,
				member_professional,
				member_sfz,
				mobile_phone,
			},
		) => (
			{
				'社会组织': organization_name,
				'姓名': member_name,
				'性别': member_sex,
				'出生日期': member_born,
				'民族': member_mz,
				'政治面貌': member_zzmm,
				'文化程度': member_educational,
				'社团职务': organization_post,
				'工作单位': member_unit,
				'职务': member_post,
				'职称': member_professional,
				'身份证号': member_sfz,
				'手机号': mobile_phone,
			}
		),
	);

	return (
		<>
			<div className="panel panel-default mt-20">
				<div className="panel-header">会议信息</div>
			</div>
			<h2 style={{textAlign: 'center'}}><b>{currentItem?.title}</b></h2>
			<h3 style={{float: 'right'}}>通知日期: {currentItem?.publishDate}</h3>
			<h3><b>通知详情：</b></h3>
			<div style={{fontSize: 16}} dangerouslySetInnerHTML={{__html: currentItem?.meetingContent}}/>

			<div className="panel panel-default mt-20">
				<div className="panel-header">参会人员信息</div>
				<br></br>
			</div>
			<Button type="primary" htmlType="button" onClick={() => {
				window.history.back();
			}}>
				返回
			</Button>
			<ExportToExcel tableData={newData}/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}
